<script setup lang="ts">
import { searchFilterOpened } from "@/analytics/events/search";
import { trackEvent } from "@/analytics/track";
import type { Props as BasePopupProps } from "@/components/ui/BasePopup/BasePopup.vue";
import DropdownMenu from "@/components/ui/DropdownMenu/DropdownMenu.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import InfoMarker from "@/components/ui/InfoMarker/InfoMarker.vue";
import type { Icon } from "@/model/icon";

withDefaults(
  defineProps<{
    name: string;
    icon: Icon;
    labelKey: string;
    selected: boolean;
    width?: BasePopupProps["width"];
  }>(),
  { width: "sm" },
);
</script>

<template>
  <DropdownMenu
    class="search-select"
    :width
    stay-open-on-content-click
    @open="trackEvent(searchFilterOpened(name))"
  >
    <template #trigger="{ isOpen }">
      <IconButton
        :icon
        data-dropdown-trigger
        :activated="isOpen"
        :aria-label="$t('label.search.filterButton', { value: $t(labelKey) })"
        :aria-expanded="isOpen"
        aria-haspopup="listbox"
      >
        <template #tooltip>
          <slot name="tooltip" />
        </template>
      </IconButton>
      <InfoMarker v-if="selected" :top="4" :right="4" />
    </template>
    <slot />
  </DropdownMenu>
</template>
